import React from "react";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { Title, Text, TextContainer } from "./acessibility.styles";

export function AcessibilityPage() {
  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Acessibilidade" },
        ]}
      />
      <div>
        <PageTitle>ACESSIBILIDADE</PageTitle>
        <TextContainer>
          <Title>Novo modelo de identidade digital padrão do governo federal atende às principais recomendações de acessibilidade indicadas para web.</Title>
          <Text>
          O termo acessibilidade significa incluir a pessoa com deficiência na participação de atividades como o uso de produtos, serviços e informações. Alguns exemplos são os prédios com rampas de acesso para cadeira de rodas e banheiros adaptados para deficientes.
          </Text>
          <Text>
Na internet, acessibilidade refere-se principalmente às recomendações do WCAG (World Content Accessibility Guide) do W3C e no caso do Governo Brasileiro ao e-MAG (Modelo de Acessibilidade em Governo Eletrônico). O e-MAG está alinhado as recomendações internacionais, mas estabelece padrões de comportamento acessível para sites governamentais.
</Text>
Na parte superior do portal existe uma barra de acessibilidade onde se encontra atalhos de navegação padronizados e a opção para alterar o contraste. Essas ferramentas estão disponíveis em todas as páginas do portal.
<Text>
Os atalhos padrões do governo federal são:
</Text>
Teclando-se Alt + 1 em qualquer página do portal, chega-se diretamente ao começo do conteúdo principal da página.
<Text>
Teclando-se Alt + 2 em qualquer página do portal, chega-se diretamente ao início do menu principal.
</Text>
Teclando-se Alt + 3 em qualquer página do portal, chega-se diretamente em sua busca interna.
<Text>
No caso do Firefox, em vez de Alt + número, tecle simultaneamente Alt + Shift + número.
</Text>
Sendo Firefox no Mac OS, em vez de Alt + Shift + número, tecle simultaneamente Ctrl + Alt + número.
<Text>
No Opera, as teclas são Shift + Escape + número. Ao teclar apenas Shift + Escape, o usuário encontrará uma janela com todas as alternativas de ACCESSKEY da página.
</Text>
<Text>
Ao final desse texto, você poderá baixar alguns arquivos que explicam melhor o termo acessibilidade e como deve ser implementado nos sites da Internet.


            
          </Text>

          <Title>  Leis e decretos sobre acessibilidade:</Title>
          <Text>
Decreto nº 5.296 de 02 de dezembro de 2004(http://www.planalto.gov.br/ccivil_03/_Ato2004-2006/2004/Decreto/D5296.htm)
</Text>
<Text>
Decreto nº 6.949, de 25 de agosto de 2009 - Promulga a Convenção Internacional sobre os Direitos das Pessoas com Deficiência e seu Protocolo Facultativo, assinados em Nova York, em 30 de março de 2007.
</Text>
<Text>
Decreto nº 7.724, de 16 de Maio de 2012 - Regulamenta a Lei No 12.527, que dispõe sobre o acesso a informações.
</Text>
Modelo de Acessibilidade de Governo Eletrônico (http://www.governoeletronico.gov.br/acoes-e-projetos/e-MAG)
<Text>
Portaria nº 03, de 07 de Maio de 2007 - formato .pdf (35,5Kb) - Institucionaliza o Modelo de Acessibilidade em Governo Eletrônico – e-MAG
</Text>
Dúvidas, sugestões e críticas
<Text>
No caso de problemas com a acessibilidade do portal, favor entrar em contato.
</Text>
        </TextContainer>
      </div>
    </>
  );
}
